import { Component, inject, input } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Router } from '@angular/router';
import { SplitButtonModule } from 'primeng/splitbutton';

@Component({
  selector: 'app-nav-bar-split-button',
  template: `
    <p-splitButton
      styleClass="p-button-text mr-2 mb-2"
      [label]="label()"
      [icon]="icon()"
      (onClick)="navigateToRouterLink()"
      [model]="model()"
    ></p-splitButton>
  `,
  styles: [`
    /* https://stackoverflow.com/questions/64647875/primeng-change-the-background-color-of-selected-button */
    ::ng-deep .p-splitbutton .p-button {
      color: var(--p-button-text-primary-color);
      background-color: var(--p-primary-100);
      border-color: transparent;
    }
    ::ng-deep .p-splitbutton .p-button:hover {
      color: var(--p-button-text-primary-color);
      background-color: var(--p-primary-200);
      border-color: transparent;
    }
    :host-context(.p-dark) ::ng-deep .p-splitbutton .p-button {
      color: var(--p-button-text-primary-color);
      background-color: var(--p-primary-900);
      border-color: transparent;
    }
    :host-context(.p-dark) ::ng-deep .p-splitbutton .p-button:hover {
      color: var(--p-button-text-primary-color);
      background-color: var(--p-primary-200);
      border-color: transparent;
    }
  `],
  standalone: true,
  imports: [SplitButtonModule],
})
export class NavBarSplitButtonComponent {
  label = input.required<string>();
  icon = input('');
  defaultRouterLink = input.required<string>();
  model = input.required<MenuItem[]>();

  private router = inject(Router);

  navigateToRouterLink() {
    this.router.navigateByUrl(this.defaultRouterLink());
  }
}
